requestAnimationFrame(() => {
  themeSettings.disableStickyHeader = () => !themeBase.isDesktop;
  themeBase.onDOMContentLoadedTrigger(() => {
    class StickyTopbar extends HTMLElement {
      constructor() {
        super();
        this.offset = 50;
        this.templateCollection = this.closest('.sticky-topbar-wrapper');
        this.spacer = this.templateCollection.querySelector('.sticky-topbar-spacer');

        window.addEventListener('MutationObserverLoaded', this.check.bind(this));
        window.addEventListener('throttle30fpsMove', this.check.bind(this));
      }

      check() {
        if (themeBounds.get(this.spacer).bottom < 0) {
          this.templateCollection.classList.add('sticky-topbar-wrapper--sticky');
        } else {
          this.templateCollection.style.setProperty('--sticky-topbar', `${themeBounds.get(this).height / 10}rem`);
          this.templateCollection.classList.remove('sticky-topbar-wrapper--sticky');
        }
      }
    }

    customElements.define('sticky-topbar', StickyTopbar);
  });
});